


























import Vue from 'vue';
import { AccountsOverview } from '@/components/account-components';
import { ThreeResourceBuckets } from '@/components/resources-components';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import { MemberAccountResponseModel } from '@/@types/member';

export default Vue.extend({
  name: 'InactiveAccounts',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getAccounts'),
      getContentArea([
        'account-column-1',
        'account-column-2',
        'account-column-3',
      ]),
    ];
    return LoadingService.watchPromises(promises)
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    accounts(): MemberAccountResponseModel[] {
      return this.$store.getters.accounts;
    },
    inactiveAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.inactiveAccounts;
    },
  },
  components: {
    ThreeResourceBuckets,
    AccountsOverview,
  },
});
